export class ResultApi {
    status: any;
    data: any;
    error: any;
    description: any;

    public constructor() {
        this.status = null;
        this.data = null;
        this.error = null;
        this.description = null;
    }

    toResult(data: any): any {
        this.status = data.status;
        this.data = data.data;
        this.error = data.error;
        this.description = data.description;

        return this;
    }
}